import { Breadcrumb } from "common/components/breadcrumb/Breadcrumb";
import { useBreadcrumbs } from "common/hooks/useBreadcrumbs";
import React from "react";
import { ContentBreadcrumbFragment_context } from "__generated__/types";
import { ContentNotWide } from "./ContentNotWide";
import { DefaultLayout } from "./DefaultLayout";
import styles from "./TallLayout.module.css";

interface Props {
  context?: ContentBreadcrumbFragment_context[];
  isAdmin?: boolean;
}

export const TallLayout: React.FC<React.PropsWithChildren<Props>> = ({
  context = [],
  isAdmin = false,
  children,
}) => {
  const breadcrumbItems = useBreadcrumbs(context, isAdmin);

  return (
    <DefaultLayout>
      {breadcrumbItems && (
        <nav className={styles.breadcrumb}>
          <Breadcrumb items={breadcrumbItems} />
        </nav>
      )}
      <ContentNotWide>{children}</ContentNotWide>
    </DefaultLayout>
  );
};
